export default __webpack_public_path__ + "static/media/file_bg.19dd8ad2.png";